import type { VariablesTab } from '@bugbug/core/types/variables';
import i18n from '~/translations';

export const TAB_LABEL: Record<VariablesTab, string> = {
  customVariables: i18n.t('variables.tabs.custom.label', 'Custom variables'),
  builtInVariables: i18n.t('variables.tabs.builtIn.label', 'Built-in variables'),
  profiles: i18n.t('variables.tabs.profile.label', 'Profiles'),
};
